var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
  'video__icon',
  'icon',
  _vm.isActive && !_vm.clicked ? 'icon--active' : _vm.clicked ? 'icon--clicked' : false
]},[_c('svg',{staticClass:"icon__ripple",attrs:{"viewBox":"0 0 100 100","fill":"none"}},_vm._l((9),function(i){return _c('circle',{key:i,attrs:{"cx":"50","cy":"50","r":"35"}})}),0),_c('img',{staticClass:"icon__hand",attrs:{"src":("/assets/img/misc/" + _vm.asset),"alt":"icon hand"}})])}
var staticRenderFns = []

export { render, staticRenderFns }